<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Keyboard shortcuts</div>

          <div class="card-body">
            ... because, sometimes, using the mouse is so mainstream! :-))<br>
            <br>
            Thus, knowing some keyboard shortcuts can make you look fancy — plus, it saves time... sometimes!<br>
            <br>
            Here are a few shortcuts you can use on the Ledgers pages:<br><br>
            <div class="row">
              <div class="col-6 col-md-4 text-md-right">
                Left arrow ◀
              </div>
              <div class="col-6 col-md-8 text-left">
                Takes you to the previous month.
              </div>
            </div>
            <div class="row">
              <div class="col-6 col-md-4 text-md-right">
                Right arrow ▶
              </div>
              <div class="col-6 col-md-8 text-left">
                Takes you to the next month.
              </div>
            </div>
            <div class="row">
              <div class="col-6 col-md-4 text-md-right">
                CTRL + T
              </div>
              <div class="col-6 col-md-8 text-left">
                Returns you to the current month.
              </div>
            </div>
            <div class="row">
              <div class="col-6 col-md-4 text-md-right">
                CTRL + E
              </div>
              <div class="col-6 col-md-8 text-left">
                Opens up the Add expense pop-up.
              </div>
            </div>
            <br>
            If you feel the need for extra shortcuts, don't hesitate to drop me a line via email <a href="mailto:support@expense.guide">support@expense.guide</a>,
            and I'll take it into consideration. Word!
            <br>
            <br>
          </div>
          <div class="floating-bottom-container"><button onclick="window.history.back()" class="btn btn-primary floating-bottom-right">Go Back</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeyboardShortcuts',
  data () {
    return {}
  }
}
</script>
